import { DataSourceMode, Label, TableRowDisplayEvent } from "@mcleod/components";
import { DateUtil, LogManager, ModelRow } from "@mcleod/core";
import { AutogenLayoutMobileCommReeferList } from "./autogen/AutogenLayoutMobileCommReeferList";

const log = LogManager.getLogger("lme.dispatch.mobilecomm.MobileCommReeferList");

export class MobileCommReeferList extends AutogenLayoutMobileCommReeferList {

    onLoad(): void | Promise<void> {
    }

    tableReeferOnRowDisplay(event: TableRowDisplayEvent) {
        const tableRow = event.getTableRow();
        const modelRow = tableRow.data as ModelRow;

        if (modelRow.get("ref_current_fuel") !== undefined && modelRow.get("ref_current_fuel_date")) {
            const labelCurrentFuelLevel = tableRow.findComponentById("labelCurrentFuelLevel") as Label;
            labelCurrentFuelLevel.text = modelRow.get("ref_current_fuel") + " as of "
                + DateUtil.formatDate(modelRow.getDate("ref_current_fuel_date"), "MM/dd/yyyy");
        }

        if (modelRow.get("ref_percent_fuel") !== undefined && modelRow.get("ref_percentage_fuel_date")) {
            const labelCurrentFuelLevel = tableRow.findComponentById("labelPercentageFuelLeft") as Label;
            labelCurrentFuelLevel.text = modelRow.get("ref_percent_fuel") + " as of "
                + DateUtil.formatDate(modelRow.getDate("ref_percentage_fuel_date"), "MM/dd/yyyy");
        }

        if (modelRow.get("ref_engine_hrs") != undefined && modelRow.get("ref_engine_hrs_date")) {
            const labelCurrentFuelLevel = tableRow.findComponentById("labelTotalEngineHours") as Label;
            labelCurrentFuelLevel.text = modelRow.get("ref_engine_hrs") + " as of "
                + DateUtil.formatDate(modelRow.getDate("ref_engine_hrs_date"), "MM/dd/yyyy");
        }

    }

    async tableReeferAfterCrudClose(event) {
        if (event.dataSourceMode === DataSourceMode.ADD || event.dataSourceMode === DataSourceMode.UPDATE) {
            this.mainDataSource.search(this.mainDataSource.lastSearch);
        }
    }
}
